// Calls the compiled Rust rules. JS only marshals strings and formats results.
import { wasmBase64 } from "./domainBytes";
interface DomainExports extends WebAssembly.Exports {
  memory: WebAssembly.Memory;
  domain_alloc: (length: number) => number;
  domain_free: (pointer: number, length: number) => void;
  domain_call: (pointer: number, length: number) => bigint;
}
const bytes = Uint8Array.from(atob(wasmBase64), (c) => c.charCodeAt(0));
const wasm = new WebAssembly.Instance(new WebAssembly.Module(bytes)).exports as DomainExports;
const encoder = new TextEncoder();
const decoder = new TextDecoder();
export function domain<T>(request: unknown): T {
  const input = encoder.encode(JSON.stringify(request));
  const pointer = wasm.domain_alloc(input.length);
  let out = 0, length = 0;
  try {
    new Uint8Array(wasm.memory.buffer, pointer, input.length).set(input);
    const packed = wasm.domain_call(pointer, input.length);
    out = Number(packed & 0xffffffffn);
    length = Number(packed >> 32n);
    return JSON.parse(decoder.decode(new Uint8Array(wasm.memory.buffer, out, length))) as T;
  } finally {
    wasm.domain_free(pointer, input.length);
    if (out) wasm.domain_free(out, length);
  }
}
export const decimalInput = (v: string | number | null) => v === null ? null : String(v);
export function revPct(price: string | null): string | null { return domain({ kind: "rev_pct", price }); }
export function forecastBucket(forecast: string | null, stage: string | null, minimum: string): string {
  return domain({ kind: "forecast", forecast, stage, minimum });
}
